import { toPostUI } from '../../../mappers/posts/toPostUI';
import { AD_COMPACT_FOOTER_HEIGHT } from '../../../ui/posts/PostAdCompactCard';
import { POST_GRID_CARD_FOOTER_HEIGHT } from '../../../ui/posts/PostCardGrid/constants';
import { calculateGridCardHeight } from '../../../ui/posts/PostCardGrid/utils';

export const getItemHeight = (itemsWithAds: any[], index: number, width: number) => {
    const postModel = itemsWithAds[index];
    if (!postModel) {
        return 0;
    }

    return postModel.isAd
        ? width + AD_COMPACT_FOOTER_HEIGHT + POST_GRID_CARD_FOOTER_HEIGHT
        : calculateGridCardHeight(width, toPostUI(postModel).content, postModel.postType);
};
